export default __webpack_public_path__ + "static/media/event-access-icon.7e088cb0.png";